import React from "react";
import url from "url";
import queryString from "query-string";
import _ from "lodash";
import MountOnInteraction from "components/MountOnInteraction";

function GoogleTagManager(props = {}) {
  const { url: urlParam } = props;

  if (typeof window === "undefined") return null;

  if (typeof window.dataLayer === "undefined") {
    window.dataLayer = [];
    window.dataLayer.push({
      originalLocation: `${document.location.protocol}//${document.location.hostname}${document.location.pathname}${document.location.search}`,
    });

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.onload = () => {
      window.dataLayer.push({ event: "gtm.js", "gtm.start": new Date().getTime(), "gtm.uniqueEventId": 0 });
    };
    script.src = `https://www.googletagmanager.com/gtm.js?id=GTM-TQ86QX`;

    document.head.appendChild(script);
  }

  window.dataLayer.push.bind(window);

  let finalUrl = url.parse(urlParam || window.location.href).path;

  const allParams = queryString.parse(queryString.extract(finalUrl));

  if (allParams.source) {
    allParams.utm_source = allParams.source;
  }

  if (allParams.kw) {
    allParams.utm_medium = allParams.kw;
  }

  const paramsToPreserve = _.pick(allParams, ["from", "utm_source", "utm_medium", "utm_content", "gclid"]);

  if (!window.localStorage.getItem("landingPage")) {
    window.localStorage.setItem("landingPage", window.location.href);
  }

  const cachedParamsToPreserve = window.localStorage.getItem("paramsPreserve")
    ? JSON.parse(window.localStorage.getItem("paramsPreserve"))
    : {};

  const finalParamsToPreserve = Object.assign({}, cachedParamsToPreserve, paramsToPreserve);
  const finalAllParams = Object.assign({}, allParams, finalParamsToPreserve);

  window.localStorage.setItem("paramsPreserve", JSON.stringify(finalParamsToPreserve));

  finalUrl = `${finalUrl.replace(/\?.+/, "")}?${queryString.stringify(finalAllParams)}`;

  if (global.lastGtmUrl !== finalUrl) {
    const event = {
      event: "VirtualPageview",
      virtualPageURL: finalUrl,
      virtualPageTitle: window.document.title,
    };

    // console.log("EVENT", event);

    window.dataLayer.push(event);
    window.gaTest && window.gaTest("set", "page", finalUrl);
    window.gaTest && window.gaTest("send", "pageview");
    global.lastGtmUrl = finalUrl;
  }

  return null;
}

export const googleEvent = (category, action, label) => {
  window.gaTest &&
    window.gaTest("send", "event", {
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
    });
};

function GoogleTagManagerWithInteractionMounting(props) {
  return <MountOnInteraction renderMounted={() => <GoogleTagManager />} />;
}

export default GoogleTagManagerWithInteractionMounting;
